import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { addDays } from "date-fns";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 

import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ReactToPrint from 'react-to-print';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
////import { styled } from '@mui/material/styles';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import Uploadfile from './Uploadfile';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
	 import InfoSharpIcon from '@mui/icons-material/InfoSharp';          
 import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

import Box from '@mui/material/Box';
import StepLabel from '@mui/material/StepLabel';
    import Sharelink from './Sharelink';   
import AddToPhotosOutlinedIcon from '@mui/icons-material/AddToPhotosOutlined';
import Payment from './Payment';
import PaymentRefBox from './Paymentdetails';
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 100,
});


const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  

  table: {
    minWidth: 750,
  },
  
});



function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}



export default class Purchaseorderviewmore extends Component {
	
    constructor(props) {
    super(props);
	
 this.state = {
	 
	 outstandingamount:0,
	 open:false, addopen: false,redirect:false,pagename:'',PaymentArray:[],
vcn_reference:'',amountpaid:0,paid:'paid',
	creditdate:'',productviewData:[],sestatus:'',vb_id :'',outstandingamt:0,
	 VendorData:[],page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],Grndtotal:0,
search:'',order:'desc' ,orderBy:'vb_id ',customername:'',taxbrkupsarr:[],taxsumarr:[],subtotal:"0.00",
	  goodthrudate:'',erropen:false,errortype:"error",errormessage:"",grandtotal:"0.00",
	urllink:'',	activeStep:0,active:'',setactiveStep:0,vb_status:0,paycount:0,paytext:"payments",PaymnetData:[],totalamount:0,lastdate:'',paidtext:'PAID',vb_vendorbillno:'',billduedate:'',duedate:'',vb_duedate:'',overduedays:'',
			pdffile:'',	
	}
	 this.updateDonenewParent=this.updateDonenewParent;     
	}
	
	
 updateDonenewParent = (event) => {
	 this.Vendorbillviewmore();
	 
 }
componentWillMount() { 

	
	  this.Vendorbillviewmore();
	

	  
	
	}
 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



Productapicall(vbid){


	axios.get(localStorage.getItem("ISIurl")+'ajaxvendorbillproduct.php?action=getall&vbp_vb_id='+vbid)
     
  .then(resp => {  	
    if(resp.data.length>0){
		let optionstaxRep = resp.data;
		let strgrandtotal=0;
				optionstaxRep.forEach(eachrep => {
					strgrandtotal=parseFloat(strgrandtotal)+parseFloat(eachrep.total);
				});
			this.setState({  
			  productviewData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   Grndtotal:strgrandtotal,outstandingamt:strgrandtotal
			},()=>{
				
				
				
				 this.GetTotalById(vbid);
				});
				
			

     }
	 
	  else{
		   this.setState({productviewData:[],totaldata:0});
	 }
	 
  
    });
}


handleClickOpen = (e) => { 
  this.setState({open:!this.state.open,
	  });
	  
		
};

handleClickOpen = (e) => { 
  this.setState({addeopn:!this.state.addeopn,
	  });
	  
		
};

Vendorbillviewmore() {
    let search = window.location.href;
    let Vbid = this.getParameterByName('vbid', search);

    axios.get(localStorage.getItem("ISIurl") + 'ajaxvendorbill.php?action=getall&vb_id=' + Vbid)
        .then(resp => {
            if (resp.data.length > 0) {

                let strname = "Purchase Order";
                this.props.parentdasCallback(strname + "~");

                this.setState({
                    VendorData: resp.data,
                    vb_id: resp.data[0].vb_id,
                    vb_billingaddress1: resp.data[0].vb_billingaddress1,
                    vb_billingaddress2: resp.data[0].vb_billingaddress2,
                    vb_billingcity: resp.data[0].vb_billingcity,
                    vb_billingpincode: resp.data[0].vb_billingpincode,
                    vb_billingcity: resp.data[0].vb_billingcity,
                    ve_contactname: resp.data[0].ve_contactname,
                    vb_billdate: resp.data[0].vb_billdate,
                    billdate: resp.data[0].billdate,
                    billduedate: resp.data[0].billduedate,
                    vb_status: resp.data[0].vb_status,
                    vb_duedate: resp.data[0].vb_duedate,
                    vb_vendorbillno: resp.data[0].vb_vendorbillno,
					pdffile:resp.data[0].vb_pdffile,
                }, () => {
                    	 this.props.parentdasCallback(
            "Purchase Order: "+resp.data[0].vb_purchaseorderno+"~"
        );
                    let strdate = resp.data[0].vb_duedate;

                    if (strdate) {
                        let dueDate = new Date(strdate);  
                        let today = new Date();  
                       
                
                        let diffTime = today- dueDate ; 
                        
                              
                        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                        
                        this.setState({ overduedays: diffDays }, () => {
                          
                           
                        });
                    } else {
                      
                    }
                });

                this.Productapicall(Vbid);
            } else {
                this.setState({ VendorData: [] });
            }

           
        })
       
}


 handlAddfileopen = () => {
	
	this.refs.Uploadfile.handleaddfileClose();
}
   handlemailopen = () => {
        const currentUrl = window.location.href; 
        this.setState({ urllink: currentUrl });
        this.setState({ open: true }); 
    }; 
	
	
	   handleCopyLink = () => {
        
        navigator.clipboard.writeText(this.state.urllink)
            .then(() => {
                alert('Link copied!');
this.setState({open:false});				
            })
           
    };
	



handleClickOpen = (e) => { 
  this.setState({open:!this.state.open
	  });
		
};



handleaddfileClose = (e) => { 
  this.setState({addopen:!this.state.addopen,
	  });
	 		
}

handlestatusupdate = (e) =>{

  let r = window.confirm("Do you really want to Dispute?");
		 if(r === true){ 
				 var formData = new FormData(); 
					 formData.append('action','statusupdate')
					formData.append('vb_id',this.state.vb_id )
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					 formData.append('vb_status',8)
				
					  axios.post(localStorage.getItem("ISIurl")+"ajaxvendorbill.php", 
					  formData, {}).then(res => {
						   this.setState({erropen: true,errormessage:'Status has been Updated',errortype:"success"}); 
						  this.Vendorbillviewmore();
	                     })
		 
		 }
	
}





handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }


Deletevendorbill = (e) =>{  
  
 
		let r = window.confirm("Do you really want to Delete?");
		 if(r === true){ 
				 var formData = new FormData(); 
					 formData.append('action','delete')
					
					 formData.append('vb_id ',this.state.vb_id )
					 formData.append('userid',localStorage.getItem("ISIuserid"))
				
					   axios.post(localStorage.getItem("ISIurl")+"ajaxvendorbill.php", 
					  formData, {}).then(res => {
						  
						  this.setState({redirect: true,pagename:'/#/Adminpurchaseorder'});  
	                     })
						
		 }
 }


/*paymentgetall */




GetTotalById(vbid) {
  axios.get(localStorage.getItem("ISIurl") + 'ajaxpayments.php?action=gettotal&pmt_type=3&pref_mainid=' + vbid)
    .then(resp => {
      if (resp.data.length > 0) {
     

        this.setState({
        lastdate:resp.data[0].lasttransaction,
        totalamount:resp.data[0].total,
		outstandingamt:parseFloat(this.state.outstandingamt)-parseFloat(resp.data[0].total),
      paycount:resp.data[0].cnt,

	  });
      } 
	  
	  
	  
	  
	  else {
        this.setState({ totalamount: 0 });
      }
	  
	  
	  
    });
}





/**/



 
   addpayrefbox(){
    let search = window.location.href;
   
    setTimeout(() => this.refs.PaymentRefBox.handleClickOpen(),500);

 }
 handleAddpayment = () => {
	
	this.refs.Payment.handleaAddpaymentClose();
}
 
 
 

	render() {
		
		  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	
let grandTotal=0;
		let subtaotal = 0;
		let totalitem=0;
		let outstandingamount=0;
		
		let balanceamoutn=0;
    return (
	
<React.Fragment>	

 <div className="paidgreebbox">
	  <p>{this.state.paidtext}</p>
	  
	  </div>
<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  
	  
	
	 
	
	  
	  
	  
	  
	  
  <div className="estimateviewcontainer">
    <div className="estimateviewerleftbox">

        <div className="custgreencolor">
          To: <span className="lighgreencolor">{this.state.ve_contactname}</span>
        </div>
        
        <div className="estaddressdata">
          <Table width="100%">
            <tr>		
              <td align="left" style={{"width": "10%"}}>	
                {this.state.VendorData.map((item,index) => { 
                  return (
                    <React.Fragment>
                      <div className="invoiceaddress">
                      
                       {this.state.vb_vendorbillno && (
                  <>
                   <p><b>Vendor Reference</b></p>
                    <p>{this.state.vb_vendorbillno}</p>
                  </>
                )}
                      </div>
                    </React.Fragment>
                  );
                })}
              </td>
			  
			  <td align="left" style={{"width": "10%"}}> 
                <p><b>Invoice Date</b></p>
                <p>{this.state.billduedate}</p>
              </td>
			  
             <td align="left" style={{"width": "10%"}}> 
                <p><b>Due Date</b></p>
                <p>{this.state.billduedate}</p>
				
				<p><b>{this.state.overduedays} Overdue</b></p>
              </td>

              

             
         

            </tr>
          </Table>
        </div>
        
		<Payment ref="Payment" 

           pref_mainid={this.state.vb_id }

          vb_status={this.state.vb_status}
          Grndtotal={this.state.outstandingamt}
updateDonenew={this.updateDonenewParent}
			   pmt_type={3}/>

	
	<PaymentRefBox 
ref="PaymentRefBox"   pmt_type={3}
outstandingamt={this.state.outstandingamt}
  pref_mainid={this.state.vb_id }


/>
		
		
        <div ref={el => (this.componentRef = el)}  >
          <Paper>
            <TableContainer className="table-container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-head" style={{"width":"40%"}} >Product</TableCell>
                    <TableCell className="table-head" style={{"width":"40%"}} >Item Description</TableCell>
                    <TableCell className="table-head" style={{"width":"5%"}}>Qty</TableCell>
                    <TableCell className="table-head " style={{"width":"10%"}}>Price</TableCell>
                    <TableCell className="table-head " style={{"width":"20%"}}>Total</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {this.state.productviewData.map((item, index) => {
                   
					
				   
                    return (
                      <React.Fragment key={index}>
                        <TableRow className="table-cell" style={{ backgroundColor: '#f1f5f6' }}>
                          <TableCell className="table-cell">
                           
                            <p><i>{item.pr_code})</i></p>
                          </TableCell>
                          <TableCell>{item.pr_description}</TableCell>
                          <TableCell>{item.qty} </TableCell>
<TableCell>{Number(item.vbp_price || 0).toFixed(2)}</TableCell>
                          
<TableCell><p>{Number(item.total || 0).toFixed(2)}</p></TableCell>
                         
                        </TableRow>
                      </React.Fragment>
                    );
                  })}


		 {this.state.productviewData.length>0 &&(
				  <React.Fragment>
                  <TableRow>
                    <TableCell colSpan="3" ></TableCell>
                    <TableCell ><b> Total</b></TableCell>
                    <TableCell align="left"><b>$ {Number(this.state.Grndtotal || 0).toFixed(2)}</b>
</TableCell>
                  </TableRow></React.Fragment>
		 )}
				 
				  
				    
				  {this.state.productviewData.length===0 &&(
				  
                 <TableRow>
                 <TableCell  >
                  No Products Found
                  </TableCell>
                </TableRow>

				  
				  
				  )}
				  
				  
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
       </div>
      
    </div>
{localStorage.getItem("ISIuserid")!=null &&(
    <div className="estimateviewerightbox">
      
	  <div className="invoiceupdatebox">
	  
		
		<div className="stepperheader">	


<div className="carbon-pod__content"><div className="s1a-timeline-container"><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-tick" aria-label="created" data-component="icon" data-element="tick" tabindex="0"></span><div className="s1a-timeline-pip-title"><span>created</span></div></div><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-default" aria-label="sent" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>sent</span></div></div><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-default" aria-label="viewed" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>viewed</span></div></div>
 {this.state.vb_status==="3" && (
<div className="s1a-timeline-pip-container"><span className={"carbon-icon s1a-timeline-pip-icon "+ this.state.invoiceclass} aria-label="invoiced" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>invoiced</span></div></div>

 )}
 {this.state.vb_status!=="3" && (
<div className="s1a-timeline-pip-container"><span className={"carbon-icon s1a-timeline-pip-icon "+ this.state.expireclass} aria-label="invoiced" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>Expired</span></div></div>
 )}
</div></div>		
		
	  </div>
		 {this.state.vb_status!=="5" && (<div className="createinvoicebox">
	
		  <h3 ><a href={'#/Addvendorbill?potype=2&vbnid='+this.state.vb_id}>Create Bill</a></h3>
		   
		
	
		</div> )}
	  
	  </div>
	  
	  
	  
	  
	  <div className="invoiceupdatebox">
	  
		
		   <div className="Viewfunctionality">
            <ul>
			<li >
            <p onClick={()=>{this.refs.Sharelink.handlSharebox()}}>
                <ShareOutlinedIcon className="verticalalign"/> &nbsp; Share Link
            </p>
             </li>
          {this.state.vb_status!=="5" && (
			 <li>
            <p className="icon-text">
             <a href={'/#/Addpurchaseorder?vbnid='+this.state.vb_id } >  <EditOutlinedIcon className="verticalalign"/> &nbsp; Edit</a>
            </p>
             </li> )}
			     <li>
            <p className="icon-text"> <a href={'/#/Addpurchaseorder?vbnid='+this.state.vb_id +'&copy=1'} >
              <ContentCopyOutlinedIcon className="verticalalign"/>&nbsp; Copy</a>
            </p>
			</li>
			 	 <li>
            <p className="icon-text" onClick={this.handlAddfileopen}>
            <AttachFileOutlinedIcon className="verticalalign"/> &nbsp; Add file
          </p>

             </li>
			 
			 
			 {this.state.vb_status!=="8" && (
			 
			     <li>
            <p className="icon-text"> 
              <InfoSharpIcon   onClick={this.handlestatusupdate} className="verticalalign"/>&nbsp; Dispute
            </p>
			</li>
			 )}
			 
			
			
		 <li>
            <p className="icon-text">
              <a  
			    href={localStorage.getItem("ISIurl")+"uploads/"+this.state.pdffile} target="_blank"
                > <CloudDownloadOutlinedIcon />&nbsp; Download</a>
            </p>
			</li>
	
			 
			 
			

        {this.state.vb_status!=="5" && (
     
			<li>
            <p className="icon-text">
              <a  
	onClick={this.Deletevendorbill}
               
                rel="noreferrer"  > <DeleteOutlineOutlinedIcon className="verticalalign"/>&nbsp; Delete</a>
            </p>
			</li>
		 )}
			
             </ul>
               </div>

	  </div>
	  
	  
	  
    </div>
	
)}
  </div>

  <div className="clear"></div>
  

  
  <Sharelink ref="Sharelink" />
  




	  
			   <Uploadfile ref="Uploadfile" id={this.state.vb_id }  strrtype={5}/>


  
   
  
  
</React.Fragment>
    );
}

}


  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  